export default [
  // Office Routes
  {
    path: "/configurations/offices",
    name: "offices",
    meta: { title: "Offices", authRequired: true },
    component: () => import("../views/configurations/offices.vue"),
  },
  {
    path: "/configurations/offices/new",
    name: "new-office",
    meta: { title: "New Office", authRequired: true },
    component: () => import("../views/configurations/new-office.vue"),
  },
  {
    path: "/configurations/offices/import",
    name: "offices-import",
    meta: { title: "Offices Import", authRequired: true },
    component: () => import("../views/configurations/office-bulk-upload.vue"),
  },
  // Department Routes
  {
    path: "/configurations/departments",
    name: "departments",
    meta: { title: "Departments", authRequired: true },
    component: () => import("../views/configurations/departments.vue"),
  },
  {
    path: "/configurations/departments/new",
    name: "new-department",
    meta: { title: "New Department", authRequired: true },
    component: () => import("../views/configurations/new-department.vue"),
  },
  {
    path: "/configurations/departments/import",
    name: "departments-import",
    meta: { title: "Departments Import", authRequired: true },
    component: () => import("../views/configurations/department-bulk-upload.vue"),
  }
];
